import { fromJS } from 'immutable'
import { put, call, takeLatest } from 'redux-saga/effects'
import axios from 'axios'
import { get } from 'lodash-es'
import { LOCATION_CHANGE } from '../store/location'
import API from '../config'

const rootApi = `${API.apiPath}/${API.apiVersion}/`

// ------------------------------------
// Constants
// ------------------------------------

const SET_ALL_PROPS = 'SET_ALL_PROPS'
const REQUEST_DEFAULT_VIEW_SETTINGS = 'REQUEST_DEFAULT_VIEW_SETTINGS'
const SET_THUMBNAIL_TYPE = 'SET_THUMBNAIL_TYPE'
const SET_LAYOUT_TYPE = 'SET_LAYOUT_TYPE'
const SET_SEARCH_TYPE = 'SET_SEARCH_TYPE'
const ADD_PROP = 'ADD_PROP'
const REMOVE_PROP = 'REMOVE_PROP'
const TO_DEFAULT = 'TO_DEFAULT'

export const PROFILE_FEED_NAME = 'Profile Tab/Page Home Feed'
export const HOME_FEED_NAME = 'Feeds Tab Home Feed'
export const VIEWSETTINGS_HIGHLIGHTS = 'viewSettings_Highlights'
export const VIEWSETTINGS_CARDS = 'viewSettings_Cards'
export const VIEWSETTINGS_COLLECTIONS = 'viewSettings_Collections'
export const VIEWSETTINGS_SAVED = 'viewSettings_Saved'

// ------------------------------------
// Actions
// ------------------------------------
export function requestDefaultViewSettings(payload) {
  return { type: REQUEST_DEFAULT_VIEW_SETTINGS, payload }
}

export function setAllProps(payload) {
  return {
    type: SET_ALL_PROPS,
    payload
  }
}

export function setThumbnailType(payload) {
  return {
    type: SET_THUMBNAIL_TYPE,
    payload
  }
}

export function setLayoutType(payload) {
  return {
    type: SET_LAYOUT_TYPE,
    payload
  }
}

export function setSearchType(payload) {
  return {
    type: SET_SEARCH_TYPE,
    payload
  }
}

export function addProp(payload) {
  return {
    type: ADD_PROP,
    payload
  }
}

export function removeProp(payload) {
  return {
    type: REMOVE_PROP,
    payload
  }
}

export function toDefault() {
  return {
    type: TO_DEFAULT
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = fromJS({
  thumbnailType: 'squared',
  layoutType: 'grid',
  hiddenInfo: ['tags', 'picks', 'likes', 'like_button', 'save_button', 'dot_menu'],
  removedInfo: [],
  screenshots: [],
  searchType: 'basic_search'
})

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_ALL_PROPS: {
      const { thumbnailType, hiddenInfo, removedInfo, layoutType } = action.payload
      return state
        .set('thumbnailType', thumbnailType || initialState.get('thumbnailType'))
        .set('hiddenInfo', hiddenInfo || initialState.get('hiddenInfo'))
        .set('removedInfo', removedInfo || initialState.get('removedInfo'))
        .set('layoutType', layoutType || initialState.get('layoutType'))
    }
    case SET_THUMBNAIL_TYPE:
      return state.set('thumbnailType', action.payload)
    case SET_LAYOUT_TYPE:
      return state.set('layoutType', action.payload)
    case SET_SEARCH_TYPE:
      return state.set('searchType', action.payload)
    case ADD_PROP: {
      const { list, prop } = action.payload
      return state.set(list, state.get(list).push(prop))
    }
    case REMOVE_PROP: {
      const { list, prop } = action.payload
      return state.set(list, state.get(list).filter(i => i !== prop))
    }
    case TO_DEFAULT:
      return initialState.set('screenshots', state.get('screenshots').push(state.filter((i, j) => j !== 'screenshots')))
    case LOCATION_CHANGE:
      if (action.payload.action === 'POP') {
        const screenshots = state.get('screenshots')
        return screenshots.get(-1).set('screenshots', screenshots.pop())
      }
      return state
  }
  return state
}

function* getDefaultViewSettings(action) {
  const url = rootApi + 'custom-feed/get'
  const { payload = {} } = action
  const { feedName } = payload
  const params = {
    feed_name: feedName
  }
  try {
    const response = yield call([axios, 'get'], url, {
      params
    })
    if (get(response, 'status') === 200) {
      const {
        feed: {
          view_settings: {
            layout_type: layoutType,
            thumbnail_type: thumbnailType,
            hidden_info: hiddenInfo,
            removed_info: removedInfo
          }
        }
      } = response.data
      yield put(setAllProps({ thumbnailType, hiddenInfo, removedInfo }))
      yield put(setLayoutType(layoutType))
    }
  } catch (e) {
    console.error(e)
  }
}

function* getDefaultViewSettingsSaga() {
  yield takeLatest(REQUEST_DEFAULT_VIEW_SETTINGS, getDefaultViewSettings)
}

export const sagas = [getDefaultViewSettingsSaga]
